import { TileVectorRenderer } from "../../vector";
import { TileMapLayer } from "../tiles.map.layer";
export class TileMapVectorLayer extends TileMapLayer {
    constructor(name, source, options, enabled = true) {
        super(name, source, options, enabled);
        if (options.style instanceof TileVectorRenderer) {
            this._renderer = options.style;
        }
        else {
            this._renderer = new TileVectorRenderer(options.style);
        }
        this._draw = this._draw ?? this._renderTile.bind(this);
    }
    _renderTile(ctx, tile, w, h) {
        this._clip(ctx, 0, 0, w, h);
        this._renderer.renderTile(tile.content, ctx, w, h);
    }
    _clip(ctx, x, y, w, h) {
        ctx.beginPath();
        ctx.rect(x, y, w, h);
        ctx.clip();
    }
}
//# sourceMappingURL=tiles.map.layer.vector.js.map